import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        activeMenuIndex: '/home', // 最后一次点击的时间，路由变化、发送请求、点击app页面时设置
    },
    mutations: {
        setActiveMenuIndex(state, activeMenuIndex){
          state.activeMenuIndex = activeMenuIndex;
        },
    },
    modules: {
        user
    }
})  


// WEBPACK FOOTER //
// ./src/store/index.js